<template>
	<div class="all_main">
		<myheader headTitle="重设密码"></myheader>
		<div class="backgroundC_white" style="padding: .15rem 0;">
			<van-field v-model="moblie" readonly label="手机号" />
		</div>
		
		<div class="margin_top_10 backgroundC_white" style="padding: .15rem 0;">
			<van-field v-model="oldpassword" :type="oldpasswordType" maxlength="30" placeholder="请输入当前密码" clearable
				label="当前密码" @clear="clearOldPassword()">
				<template v-if="oldpassword.length>0" slot="right-icon">
					<img style="width: 20px;height: 20px; object-fit: contain;"
						:src="oldpasswordType==='password'?showPass:hidePass" @click="switchOldPasswordType()">
				</template>
			</van-field>
		</div>
		<div class="backgroundC_white" style="padding: .15rem 0;">
			<van-field v-model="password" :type="passwordType" maxlength="30" placeholder="不少于8位，包含数字、大小写字母、特殊字符"
				clearable label="新的密码" @clear="clearPassword()">
				<template v-if="password.length>0" slot="right-icon">
					<img style="width: 20px;height: 20px; object-fit: contain;"
						:src="passwordType==='password'?showPass:hidePass" fill @click="switchPasswordType()">
				</template>
			</van-field>
		</div>
		<div class="backgroundC_white" style="padding: .15rem 0;">
			<van-field v-model="repassword" :type="repasswordType" maxlength="30" placeholder="请输入确认密码" clearable
				label="确认密码" @clear="clearRePassword()">
				<template v-if="repassword.length>0" slot="right-icon">
					<img style="width: 20px;height: 20px; object-fit: contain;"
						:src="repasswordType==='password'?showPass:hidePass" @click="switchRePasswordType()">
				</template>
			</van-field>
		</div>
		<div class="all_tips_bottom_card">
			<button class="all_button24 width_100 text16 bmain_active" @click="sumbit()">确定</button>
		</div>
	</div>
</template>


<script>
	import Vue from 'vue';
	import {
		Field
	} from 'vant';
	//Vue.use(Field);
	export default {
		components: {
			[Field.name]: Field,
		},
		data() {
			return {
				//手机号
				moblie: '',
				//当前密码
				oldpassword:'',
				//密码输入框类型
				oldpasswordType: 'password',
				//密码
				password: '',
				//密码输入框类型
				passwordType: 'password',
				//确认密码
				repassword: '',
				//确认密码输入框类型
				repasswordType: 'password',
				//显示
				showPass: require('../../assets/images/show_password.svg'),
				//隐藏
				hidePass: require('../../assets/images/hide_password.svg')
			}
		},
		methods: {
			//脱敏
			toDesensitize(moblie) {
				return mobile.replace(/^(\d{3})\d+(\d{4})$/, "$1****$2")
			},
			//清空密码
			clearOldPassword() {
				this.oldpasswordType = 'password'
			},
			//清空密码
			clearPassword() {
				this.passwordType = 'password'
			},
			//清空确认密码
			clearRePassword() {
				this.repasswordType = 'password'
			},
			//切换密码类型
			switchOldPasswordType() {
				if (this.oldpasswordType === 'password') {
					this.oldpasswordType = 'text'
				} else {
					this.oldpasswordType = 'password'
				}
			},
			//切换密码类型
			switchPasswordType() {
				if (this.passwordType === 'password') {
					this.passwordType = 'text'
				} else {
					this.passwordType = 'password'
				}
			},
			//切换确认密码类型
			switchRePasswordType() {
				if (this.repasswordType === 'password') {
					this.repasswordType = 'text'
				} else {
					this.repasswordType = 'password'
				}
			},
			//修改密码
			sumbit() {
				this.oldpassword = this.oldpassword.trim()
				this.password = this.password.trim()
				this.repassword = this.repassword.trim()
				let exp = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*;?:])[\da-zA-Z~!@#$%^&*;?:]{8,}$/;
				if(!this.oldpassword){
					this.$Toast("请输入当前密码！");
					return
				}
				if (!this.password) {
					this.$Toast("请输入密码！");
					return
				}
				if (!this.repassword) {
					this.$Toast("请输入确认密码！");
					return
				}
				if (this.password !== this.repassword) {
					this.$Toast("密码不一致！");
					return
				}
				if (this.password.length < 8) {
					this.$Toast("密码不能少于8位！");
					return
				}
				if (!exp.test(this.password)) {
					this.$Toast("密码需要同时包含数字、字母、特殊字符！");
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/my/api/resetPassword", {
					oldPassword: this.oldpassword,
					newPassword: this.password
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast("修改成功，请重新登录！");
						window.localStorage.setItem("LoginInfo", '')
						window.localStorage.setItem("Identity_Token", '')
						this.$store.commit("changeLoginInfo", '')
						this.$store.commit("changeLoginToken", '')
						this.$store.dispatch("actionUserInfo", '');
						this.reLogin()
					} else {
						this.$Toast(res.message || "修改失败，请重试！");
					}
				}).catch(err=>{
					console.log('/my/api/resetPassword-=',err)
					this.$store.dispatch(this.$LoadShow, false)
				})
			},
			//重新登录
			reLogin() {
				setTimeout(() => {
					this.$router.push('/login')
				}, 500)
			},
			//获取个人信息
			getUserInfo() {
				if (!this.$store.state.userInfo) {
					this.$store.dispatch(this.$LoadShow, true)
					this.$post("/my/api/getDetailForMobile")
						.then((res) => {
							this.$store.dispatch(this.$LoadShow, false)
							if (res.success && res.data) {
								this.$store.dispatch("actionUserInfo", res.data);
								this.moblie = this.$store.state.userInfo.mobile.replace(/^(\d{3})\d+(\d{4})$/,
									"$1****$2")
							}
						});
				} else {
					this.moblie = this.$store.state.userInfo.mobile.replace(/^(\d{3})\d+(\d{4})$/, "$1****$2")
				}
			},
		},
		mounted() {
			this.getUserInfo()
		}
	}
</script>


<style scoped lang="scss">
	@import "../../styles/global.css";

	::v-deep .van-field__label {
		width: 2.8rem;
	}

	::v-deep .van-field__right-icon {
		height: 20px;
	}
</style>